import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles({
  footerContentWrapper: {
    width: '100%',
    height: '40vh',
    background: "#C62368",
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    alignItems: 'center',
  }
})

export default useStyles